
function SpecificationLabel(props) {

    return (
        <div className='spesificationLabel'><pre>{JSON.stringify(props.data, null, 2)}</pre></div>
    );
}

export default SpecificationLabel;